module.exports = __webpack_public_path__ + "static/media/future-ui.e8eee30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonusView/future-ui.svg
// module id = 479
// module chunks = 0